import { Injectable } from '@angular/core';

export const RD_CONSTRAINTS = {
  monthlyDeposit: { min: 100, max: 500_000, step: 100 },
  rate:           { min: 3,   max: 12,      step: 0.1 },
  tenureMonths:   { min: 6,   max: 120,     step: 3   }
} as const;

export interface RdMonthRow {
  month: number;
  invested: number;
  balance: number;
}

export interface RdResult {
  months: RdMonthRow[];
  totalInvested: number;
  totalInterest: number;
  maturityValue: number;
}

@Injectable({ providedIn: 'root' })
export class RdCalculatorService {

  /** Standard Indian bank RD: monthly deposits, interest compounded quarterly on the running balance. */
  calculate(monthlyDeposit: number, annualRate: number, tenureMonths: number): RdResult {
    const i = annualRate / 100 / 4;

    const months: RdMonthRow[] = [];
    let balance = 0;
    let invested = 0;

    for (let m = 1; m <= tenureMonths; m++) {
      balance += monthlyDeposit;
      invested += monthlyDeposit;
      if (m % 3 === 0) balance *= (1 + i);
      months.push({ month: m, invested, balance });
    }

    const maturityValue = months.length ? months[months.length - 1].balance : 0;

    return { months, totalInvested: invested, totalInterest: maturityValue - invested, maturityValue };
  }
}
